// import { Layout } from 'lucide-react'
// import React, { useEffect, useState } from 'react'
// import FooterNew from '../../Layout/FooterNew'
// import { Link } from 'react-router-dom';
// import axios from 'axios';

// const BASE_URL = "https://ecom.cyberathon.com";
// function Wishlist() {
//     const [wishlistProducts,setWishlistProducts] = useState([]);
//     const [loading, setLoading] = useState(true);
// const userId = sessionStorage.getItem("userId");

// useEffect(()=>{
//     loadWishlist();
// },[userId])

//     // useEffect(()=>{
//     //     loadWishlist();
//     // },[])

//     const loadWishlist = async () =>{
//         const userId = sessionStorage.getItem("userId");
//         // if (!userId) return;
//         if(!userId){
//           setWishlistProducts([]);
//           setLoading(false);
//           return;
//         }
//         try{
//             const res = await axios.post(
//                 `${BASE_URL}/index.php/Api/list_wishlist`,
//                 {user_id:userId}
//             );
//             if(res.data.status === "true"){
//                 setWishlistProducts(res.data.data);
//             }
//           }catch(error){
//             console.error(error);
//             }finally{
//                 setLoading(false);
//             }
//     };
//      const removeFromWishlist = async (wish_id) => {
//     const userId = sessionStorage.getItem("userId");

//     try {
//       await axios.post(
//         `${BASE_URL}/index.php/Api/delete_wish_list`,
//         {
//           user_id: userId,
//           wish_id: wish_id
//         }
//       );

//       setWishlistProducts(prev =>
//         prev.filter(item => item.wish_id !== wish_id)
//       );

//     } catch (err) {
//       console.error(err);
//     }
//   };
//   return (
//     <>
//     <Layout/>
//     <div className='container-fluid px-lg-5 px-2 py-4'>
//     <h3 className='mb-3'>My Wishlist</h3>
//     {loading ? (
//         <p>Loading...</p>
//     ):wishlistProducts.length === 0 ?(
//          <p>No items in wishlist</p>
//     ):(
// <div className='row'>
//     {
//         wishlistProducts.map((p)=>(
// <div className='col-6 col-md-3 col-lg-3 mb-3'>
//     <div className='card custom-card'>
//     <div className='position-relative'>
//     <Link to={`/DetailsSection3/${p.prod_id}`}>
//     <img
//     src={`${BASE_URL}/${p.Product_image?.[0]}`}
//     className='card-img-top mt-1'
//     alt={p.Product_name}
//     />
//     </Link>
//     <i
//      className="bi bi-suit-heart-fill text-danger position-absolute top-0 end-0 m-2 fs-5 bg-white rounded-circle px-2 py-1 shadow"
//     style={{ cursor: "pointer" }}
//      onClick={() => removeFromWishlist(p.wish_id)}
//     ></i>
//     </div>
//     <div className='card-body'>
//         <h6 className='fw-bold'>{p.Product_name}</h6>
//         <p className='text-success fw-bold'> ₹{p.current_price}</p>
//     </div>
//     </div>
//     </div>
//         ))
//     }
    
//     </div>
//     )

//     }
    
//     </div>
//     <FooterNew/>
//     </>
//   )
// }

// export default Wishlist;


// import React, { useEffect, useState } from 'react';
// import Layout from '../../Layout/Layout';
// import FooterNew from '../../Layout/FooterNew';
// import { Link } from 'react-router-dom';
// import axios from 'axios';
// import { useWishlist } from '../../../Context/WishlistContext'; // ✅ Import

// const BASE_URL = "https://ecom.cyberathon.com";

// function Wishlist() {
//   const [wishlistProducts, setWishlistProducts] = useState([]);
//   const [loading, setLoading] = useState(true);
  
//   // ✅ Context se wishlistItems lao
//   const { wishlistItems, toggleWishlist } = useWishlist();
  
//   const userId = sessionStorage.getItem("userId");

//   // ✅ Jab bhi wishlistItems change ho, products fetch karo
//   useEffect(() => {
//     loadWishlistProducts();
//   }, [wishlistItems, userId]);

//   const loadWishlistProducts = async () => {
//     setLoading(true);

//     // ✅ Guest user check
//     if (!userId) {
//       // Guest user ke liye localStorage se IDs lao
//       const guestWishlist = JSON.parse(localStorage.getItem("guest_wishlist")) || [];
      
//       if (guestWishlist.length === 0) {
//         setWishlistProducts([]);
//         setLoading(false);
//         return;
//       }

//       // Guest wishlist IDs se products fetch karo
//       try {
//         const productPromises = guestWishlist.map(prod_id =>
//           axios.get(`${BASE_URL}/index.php/Api/get_product_details/${prod_id}`)
//         );
//         const responses = await Promise.all(productPromises);
//         const products = responses.map(res => res.data.product);
//         setWishlistProducts(products);
//       } catch (error) {
//         console.error("Guest wishlist fetch error:", error);
//       } finally {
//         setLoading(false);
//       }
//       return;
//     }

//     // ✅ Logged-in user ke liye backend se fetch
//     try {
//       const res = await axios.post(
//         `${BASE_URL}/index.php/Api/list_wishlist`,
//         { user_id: userId }
//       );

//       if (res.data.status === "true") {
//         setWishlistProducts(res.data.data);
//       } else {
//         setWishlistProducts([]);
//       }
//     } catch (error) {
//       console.error("Wishlist fetch error:", error);
//       setWishlistProducts([]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   // ✅ Remove function - Context se call karo
//   const handleRemove = (prod_id) => {
//     toggleWishlist(prod_id); // Context function use karo
//   };

//   return (
//     <>
//       <Layout />
//       <div className='container-fluid px-lg-5 px-2 py-4'>
//         <h3 className='mb-3'>My Wishlist</h3>

//         {loading ? (
//           <div className="text-center py-5">
//             <div className="spinner-border text-primary" role="status">
//               <span className="visually-hidden">Loading...</span>
//             </div>
//             <p className="mt-3">Loading wishlist...</p>
//           </div>
//         ) : wishlistProducts.length === 0 ? (
//           <div className="text-center py-5">
//             <i className="bi bi-heart fs-1 text-muted"></i>
//             <p className="mt-3 text-muted">Your wishlist is empty</p>
//             <Link to="/products" className="btn btn-primary mt-2">
//               Browse Products
//             </Link>
//           </div>
//         ) : (
//           <div className='row'>
//             {wishlistProducts.map((p) => (
//               <div className='col-6 col-md-3 col-lg-3 mb-3' key={p.prod_id}>
//                 <div className='card custom-card'>
//                   <div className='position-relative'>
//                     <Link to={`/DetailsSection3/${p.prod_id}`}>
//                       <img
//                         src={`${BASE_URL}/${p.Product_image}`}
//                         className='card-img-top mt-1'
//                         alt={p.Product_name}
//                       />
//                     </Link>
//                     <i
//                       className="bi bi-suit-heart-fill text-danger position-absolute top-0 end-0 m-2 fs-5 bg-white rounded-circle px-2 py-1 shadow"
//                       style={{ cursor: "pointer" }}
//                       onClick={() => handleRemove(p.prod_id)} // ✅ Context function
//                     ></i>
//                   </div>
//                   <div className='card-body'>
//                     <h6 className='fw-bold one-line-ellipsis'>{p.Product_name}</h6>
//                     <p className='text-success fw-bold mb-0'>₹{p.current_price}</p>
//                     {p.old_price && (
//                       <small className="text-muted text-decoration-line-through">
//                         ₹{p.old_price}
//                       </small>
//                     )}
//                   </div>
//                 </div>
//               </div>
//             ))}
//           </div>
//         )}
//       </div>
//       <FooterNew />
//     </>
//   );
// }

// export default Wishlist;

// 14feb
// import React, { useEffect, useState } from 'react';
// import Layout from '../../Layout/Layout';
// import FooterNew from '../../Layout/FooterNew';
// import { Link } from 'react-router-dom';
// import { useWishlist } from '../../../Context/WishlistContext';
// import axios from 'axios';

// const BASE_URL = "https://ecom.cyberathon.com";

// function Wishlist() {
//   const [wishlistProducts, setWishlistProducts] = useState([]);
//   const [loading, setLoading] = useState(true);
  
//   // ✅ Context se functions lao
//   const { wishlistItems, toggleWishlist, loadWishlist } = useWishlist();
  
//   const userId = sessionStorage.getItem("userId");

//   // ✅ Load products when wishlistItems change
//   useEffect(() => {
//     loadWishlistProducts();
//   }, [wishlistItems]);

//   const loadWishlistProducts = async () => {
//     if (!userId) {
//       setWishlistProducts([]);
//       setLoading(false);
//       return;
//     }

//     setLoading(true);

//     try {
//       const res = await axios.post(
//         `${BASE_URL}/index.php/Api/list_wishlist`,
//         { user_id: userId }
//       );

//       if (res.data.status === "true") {
//         setWishlistProducts(res.data.data || []);
//       } else {
//         setWishlistProducts([]);
//       }
//     } catch (error) {
//       console.error("❌ Wishlist fetch error:", error);
//       setWishlistProducts([]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   // ✅ Remove handler - Context function use karo
//   const handleRemove = (prod_id) => {
//     console.log("🗑️ Removing prod_id:", prod_id);
//     toggleWishlist(prod_id); // ✅ Context will handle wish_id lookup
//   };

//   return (
//     <>
//       <Layout />
//       <div className='container-fluid px-lg-5 px-2 py-4'>
//         <h3 className='mb-3'>My Wishlist</h3>

//         {loading ? (
//           <div className="text-center py-5">
//             <div className="spinner-border text-primary" role="status">
//               <span className="visually-hidden">Loading...</span>
//             </div>
//             <p className="mt-3">Loading wishlist...</p>
//           </div>
//         ) : wishlistProducts.length === 0 ? (
//           <div className="text-center py-5">
//             <i className="bi bi-heart fs-1 text-muted"></i>
//             <p className="mt-3 text-muted">Your wishlist is empty</p>
//             <Link to="/products" className="btn btn-primary mt-2">
//               Browse Products
//             </Link>
//           </div>
//         ) : (
//           <div className='row'>
//             {wishlistProducts.map((p) => (
//               <div className='col-6 col-md-3 col-lg-3 mb-3' key={p.prod_id}>
//                 <div className='card custom-card'>
//                   <div className='position-relative'>
//                     <Link to={`/DetailsSection3/${p.prod_id}`}>
//                       <img
//                         src={`${BASE_URL}/${p.Product_image}`}
//                         className='card-img-top mt-1'
//                         alt={p.Product_name}
//                       />
//                     </Link>
//                     <i
//                       className="bi bi-suit-heart-fill text-danger position-absolute top-0 end-0 m-2 fs-5 bg-white rounded-circle px-2 py-1 shadow"
//                       style={{ cursor: "pointer" }}
//                       onClick={() => handleRemove(p.prod_id)} // ✅ prod_id pass karo
//                     ></i>
//                   </div>
//                   <div className='card-body'>
//                     <h6 className='fw-bold one-line-ellipsis'>{p.Product_name}</h6>
//                     <p className='text-success fw-bold mb-0'>₹{p.current_price}</p>
//                     {p.old_price && (
//                       <small className="text-muted text-decoration-line-through">
//                         ₹{p.old_price}
//                       </small>
//                     )}
//                   </div>
//                 </div>
//               </div>
//             ))}
//           </div>
//         )}
//       </div>
//       <FooterNew />
//     </>
//   );
// }

// export default Wishlist;


// New 19 feb
import React, { useEffect, useState } from 'react';
import Layout from '../../Layout/Layout';
import FooterNew from '../../Layout/FooterNew';
import { Link } from 'react-router-dom';
import { useWishlist } from '../../../Context/WishlistContext';
import axios from 'axios';
import { useCart } from '../../../Context/CartContext';
import { AddToCart } from '../Products/AddtoCart';
import SEO from '../../SEO';

const BASE_URL = "https://ecom.cyberathon.com";

function Wishlist() {
  const [wishlistProducts, setWishlistProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [addedItems, setAddedItems] = useState([]);
  const {setCartCount} = useCart();
const [seoData, setSeoData] = useState({});
  // ✅ Context se functions lao
  const { wishlistItems, toggleWishlist, loadWishlist } = useWishlist();
  const formatCardDescription = (html) => {
  if (!html) return "";

  return html
    // HTML tags remove
    .replace(/<[^>]*>/g, " ")
    // number. text → sirf text
    .replace(/\d+\./g, "")
    // multiple spaces clean
    .replace(/\s+/g, " ")
    .trim();
};
  const userId = sessionStorage.getItem("userId");

  // ✅ Load products when wishlistItems change
  useEffect(() => {
    loadWishlistProducts();
    loadCartItems();
  }, [wishlistItems]);

  const loadWishlistProducts = async () => {
    if (!userId) {
      setWishlistProducts([]);
      setLoading(false);
      return;
    }

    setLoading(true);

    try {
      const res = await axios.post(
        `${BASE_URL}/index.php/Api/list_wishlist`,
        { user_id: userId }
      );

      if (res.data.status === "true") {
        setWishlistProducts(res.data.data || []);
      } else {
        setWishlistProducts([]);
      }
    } catch (error) {
      console.error("❌ Wishlist fetch error:", error);
      setWishlistProducts([]);
    } finally {
      setLoading(false);
    }
  };

  const loadCartItems = async () => {
    const userId = sessionStorage.getItem("userId");
    const cartToken = localStorage.getItem("cart_token");
    if(!userId && !cartToken) return;
    try{
      const res = await axios.post(
        `${BASE_URL}/index.php/Api/list_cart`,
        {
          user_id: userId ? userId:null,
          cart_token:userId?null:cartToken
        }
      );
      if(res.data.status){
        const prodIds = res.data.cart_items.map(item=>item.prod_id);
        setAddedItems(prodIds);
      }
    }catch(err){
      console.error(err);
    }
  };

  const handleAddToCart = async (prod_id) =>{
    try{
      const res = await AddToCart(prod_id,1);
      if(res.data.status === true){
        setAddedItems(prev => [...prev,prod_id]);
        setCartCount(prev=>prev+1);
      }else{
        alert(res.data.message);
      }
    }catch(err){
      console.error(err);
      alert("Error while adding to cart");
    }
  };

  // ✅ Remove handler - Context function use karo
  const handleRemove = (prod_id) => {
    console.log("🗑️ Removing prod_id:", prod_id);
    toggleWishlist(prod_id); // ✅ Context will handle wish_id lookup
    setWishlistProducts(prev => 
      prev.filter(item => item.prod_id !== prod_id)
    );
  };
  const renderStars = (rating) => {
    const stars = [];
    const fullStars = Math.floor(rating);      
    const hasHalfStar = rating % 1 !== 0;       
    const emptyStars = 5 - Math.ceil(rating);   

    for (let i = 0; i < fullStars; i++) {
      stars.push(<i key={"f" + i} className="fa-solid fa-star text-warning"></i>);
    }
    if (hasHalfStar) {
      stars.push(<i key="half" className="fa-solid fa-star-half-stroke text-warning"></i>);
    }
    for (let i = 0; i < emptyStars; i++) {
      stars.push(<i key={"e" + i} className="fa-regular fa-star text-warning"></i>);
    }

    return stars;
  };

  useEffect(() => {
  const fetchSeo = async () => {
    try {
      const response = await axios.post(
        `${BASE_URL}/index.php/Api/get_seo_by_page`,
        {
          page_name: 'wishlist'
        }
      );

      if (response.data.status === 'true') {
        const data = response.data.data;
        setSeoData({
          title: data.meta_title,
          description: data.meta_description,
          keywords: data.meta_keywords,
          canonical: data.canonical_url,
        });
      }
    } catch (error) {
      console.error('SEO fetch error:', error);
    }
  };

  fetchSeo();
}, []);

  return (
    <>
    <SEO
    title={seoData.title || "My Wishlist | ShopeIndia"}
    description={seoData.description || "View your saved wishlist products on ShopeIndia."}
    keywords={seoData.keywords || "wishlist, saved products, shopeindia"}
    canonical={seoData.canonical || "https://www.shopeindia.co.in/wishlist"}
  />
      <Layout />
      <div className='container-fluid px-lg-5 px-2 py-4'>
        <h3 className='mb-3'>My Wishlist</h3>

        {loading ? (
          <div className="text-center py-5">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
            <p className="mt-3">Loading wishlist...</p>
          </div>
        ) : wishlistProducts.length === 0 ? (
          <div className="text-center py-5">
            <i className="bi bi-heart fs-1 text-muted"></i>
            <p className="mt-3 text-muted">Your wishlist is empty</p>
            <Link to="/products" className="btn btn-primary mt-2">
              Browse Products
            </Link>
          </div>
        ) : (
          <div className='row'>
            {wishlistProducts.map((p) => (
              <div className='col-6 col-md-3 col-lg-3 mb-3' key={p.prod_id}>
                <div className='card custom-card'>
                  <div className='position-relative'>
                    <Link to={`/DetailsSection3/${p.prod_id}`}>
                      <img
                        src={`${BASE_URL}/${p.Product_image?.[0]}`}
                        className='card-img-top mt-1'
                        alt={p.Product_name}
                      />
                    </Link>
                    <i
                      className="bi bi-suit-heart-fill text-danger position-absolute top-0 end-0 m-2 fs-5 bg-white rounded-circle px-2 py-1 shadow"
                      style={{ cursor: "pointer" }}
                      onClick={() => handleRemove(p.prod_id)} // ✅ prod_id pass karo
                    ></i>
                  </div>
                  <div className='card-body'>
                    <h6 className='fw-bold two-line-ellipsis product-title'>{p.Product_name}</h6>
                    <small className="d-block desc-space one-line-ellipsis">
  {/* {p.discription ? p.discription : "\u00A0"} */}
    {p.discription?.trim() ? formatCardDescription(p.discription) : "\u00A0"}
</small>
                   <div className="price-space">
  {p.current_price ? (
    <>
      <p className="text-success fw-bold mb-0">₹{p.current_price}</p>
      {p.old_price && (
        <small className="text-muted text-decoration-line-through">
          ₹{p.old_price}
        </small>
      )}
    </>
  ) : (
    "\u00A0"
  )}
</div>
<div className="rating-space">
  {p.rating ? (
    <>
      {renderStars(p.rating)}
      <small className="text-dark ms-1">({p.rating})</small>
    </>
  ) : (
    "\u00A0"
  )}
</div>
                    <div
  className="bg-col text-white fw-semibold py-2 rounded text-center mt-2"
  style={{
    cursor: addedItems.includes(p.prod_id)
      ? "default"
      : "pointer"
  }}
  onClick={() =>
    !addedItems.includes(p.prod_id) &&
    handleAddToCart(p.prod_id)
  }
>
  {addedItems.includes(p.prod_id) ? (
    <>
      Added <span className="ms-2">
        <i className="bi bi-check2"></i>
      </span>
    </>
  ) : (
    <>
      Add to Cart <span className="ms-2">
        <i className="bi bi-bag"></i>
      </span>
    </>
  )}
</div>

                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
      <FooterNew />
    </>
  );
}

export default Wishlist;